import { render } from "./LikeNotificationVideo.vue?vue&type=template&id=3bc36d73"
import script from "./LikeNotificationVideo.vue?vue&type=script&lang=js"
export * from "./LikeNotificationVideo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\Vue3\\player-video-pepsi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__